import ObjectStateActionUtils from "../utils/ObjectStateActionUtils";
import Logger from "../../../utils/Logger";
import AxiosHttpClient from "../../../utils/HttpClient";
const TAG = 'ObjectManagerBase';
export default class ObjectManagerBase {
    static handleLoadSuccess(object, data, reduxSpec, successCallback) {
        if (reduxSpec)
            ObjectStateActionUtils.dispatchObjectLoadSuccess(object, reduxSpec.reduxStateKey, reduxSpec.dispatch);
        if (successCallback)
            successCallback(object, data);
    }
    static handleLoadError(error, reduxSpec, errorCallback) {
        if (reduxSpec)
            ObjectStateActionUtils.dispatchObjectLoadFailed(error, reduxSpec.reduxStateKey, reduxSpec.dispatch);
        if (errorCallback) {
            errorCallback(error);
        }
        else {
            return Promise.reject(error);
        }
    }
    static handleReLoadSuccess(object, data, reduxSpec, successCallback) {
        if (reduxSpec)
            ObjectStateActionUtils.dispatchObjectReLoadSuccess(object, reduxSpec.reduxStateKey, reduxSpec.dispatch);
        if (successCallback)
            successCallback(object, data);
    }
    static handleReLoadError(error, reduxSpec, errorCallback) {
        if (reduxSpec)
            ObjectStateActionUtils.dispatchObjectReLoadFailed(error, reduxSpec.reduxStateKey, reduxSpec.dispatch);
        if (errorCallback) {
            errorCallback(error);
        }
        else {
            return Promise.reject(error);
        }
    }
    static handleSaveSuccess(object, data, reduxSpec, successCallback) {
        if (reduxSpec)
            ObjectStateActionUtils.dispatchObjectSaveSuccess(object, reduxSpec.reduxStateKey, reduxSpec.dispatch);
        if (successCallback)
            successCallback(object);
    }
    static handleSaveError(error, reduxSpec, errorCallback) {
        if (reduxSpec)
            ObjectStateActionUtils.dispatchObjectSaveFailed(error, reduxSpec.reduxStateKey, reduxSpec.dispatch);
        if (errorCallback) {
            errorCallback(error);
        }
        else {
            return Promise.reject(error);
        }
    }
    loadObject(requestUrl, objectKey, successCallback, errorCallback) {
        return this.loadObjectWithRedux(requestUrl, objectKey, null, successCallback, errorCallback);
    }
    async reLoadObjectWithRedux(requestUrl, objectKey, reduxSpec, successCallback, errorCallback) {
        Logger.info(TAG, `Reloading ${objectKey} based on lookup from ${requestUrl}...`);
        if (reduxSpec)
            ObjectStateActionUtils.dispatchObjectReLoadStarted(reduxSpec.reduxStateKey, reduxSpec.dispatch);
        const client = new AxiosHttpClient();
        try {
            const data = await client.get(requestUrl);
            if (data.hasOwnProperty(objectKey)) {
                Logger.info(TAG, `Found ${objectKey}`);
                const object = data[objectKey];
                ObjectManagerBase.handleReLoadSuccess(object, data, reduxSpec, successCallback);
                return object;
            }
            const error = {
                id: 'not_found'
            };
            return ObjectManagerBase.handleReLoadError(error, reduxSpec, errorCallback);
        }
        catch (error) {
            return ObjectManagerBase.handleReLoadError(error, reduxSpec, errorCallback);
        }
    }
    async loadObjectWithRedux(requestUrl, objectKey, reduxSpec, successCallback, errorCallback) {
        Logger.info(TAG, `Fetching ${objectKey} based on lookup from ${requestUrl}...`);
        if (reduxSpec)
            ObjectStateActionUtils.dispatchObjectLoadStarted(reduxSpec.reduxStateKey, reduxSpec.dispatch);
        const client = new AxiosHttpClient();
        try {
            const data = await client.get(requestUrl);
            if (data.hasOwnProperty(objectKey)) {
                Logger.info(TAG, `Found ${objectKey}`);
                const object = data[objectKey];
                ObjectManagerBase.handleLoadSuccess(object, data, reduxSpec, successCallback);
                return object;
            }
            const error = {
                id: 'not_found'
            };
            return ObjectManagerBase.handleLoadError(error, reduxSpec, errorCallback);
        }
        catch (error) {
            return ObjectManagerBase.handleLoadError(error, reduxSpec, errorCallback);
        }
    }
    loadFirstObject(requestUrl, objectKey, successCallback, errorCallback) {
        this.loadFirstObjectWithRedux(requestUrl, objectKey, null, successCallback, errorCallback);
    }
    async loadFirstObjectWithRedux(requestUrl, objectKey, reduxSpec, successCallback, errorCallback) {
        Logger.info(TAG, `Fetching ${objectKey} based on lookup from ${requestUrl}...`);
        if (reduxSpec)
            ObjectStateActionUtils.dispatchObjectLoadStarted(reduxSpec.reduxStateKey, reduxSpec.dispatch);
        const client = new AxiosHttpClient();
        try {
            const data = await client.get(requestUrl);
            if (data.hasOwnProperty(objectKey) && Array.isArray(data[objectKey]) && data[objectKey].length > 0) {
                Logger.info(TAG, `Found one ${objectKey}`);
                const resultArray = data[objectKey];
                const object = resultArray[0];
                ObjectManagerBase.handleLoadSuccess(object, data, reduxSpec, successCallback);
                return object;
            }
            const error = {
                id: 'not_found'
            };
            return ObjectManagerBase.handleLoadError(error, reduxSpec, errorCallback);
        }
        catch (error) {
            return ObjectManagerBase.handleLoadError(error, reduxSpec, errorCallback);
        }
    }
    saveObject(requestUrl, object, objectKey, successCallback, errorCallback) {
        this.saveObjectWithRedux(requestUrl, object, objectKey, null, successCallback, errorCallback);
    }
    async saveObjectWithRedux(requestUrl, object, objectKey, reduxSpec, successCallback, errorCallback) {
        Logger.info(TAG, `Saving object using ${requestUrl}...`);
        if (reduxSpec)
            ObjectStateActionUtils.dispatchObjectSaveStarted(object, reduxSpec.reduxStateKey, reduxSpec.dispatch);
        const client = new AxiosHttpClient();
        try {
            const data = await client.post(requestUrl, { [objectKey]: object });
            if (data.hasOwnProperty(objectKey)) {
                Logger.info(TAG, `Saved ${objectKey}`);
                const object = data[objectKey];
                ObjectManagerBase.handleSaveSuccess(object, data, reduxSpec, successCallback);
                return object;
            }
            Logger.error(TAG, `Save of ${objectKey} was successful, but response did not contain updated version`);
            const error = {
                id: 'save_failed'
            };
            return ObjectManagerBase.handleSaveError(error, reduxSpec, errorCallback);
        }
        catch (error) {
            return ObjectManagerBase.handleSaveError(error, reduxSpec, errorCallback);
        }
    }
}
//# sourceMappingURL=ObjectManagerBase.js.map